import { isBlankString } from 'libs/end-to-end/src/generic';
import { TransformUniqueValuesByColumnItem } from 'libs/end-to-end/src/types/databases/transform/transform-insights';
import { errResult } from 'libs/end-to-end/src/result';
import { okResult } from 'libs/end-to-end/src/result';
import { Result } from 'libs/end-to-end/src/result';
import { UnknownError } from 'libs/end-to-end/src/types/errors/unknown-error';

export const checkIsMetricBoolean = (
  metricColumnHeaderValue: string,
  uniqueColumnValues: TransformUniqueValuesByColumnItem[],
): Result<boolean, UnknownError> => {
  const uniqueMetricValues = uniqueColumnValues.find(
    (column) => column.columnName === metricColumnHeaderValue,
  );

  if (!uniqueMetricValues) {
    return errResult({
      errorType: 'UnknownError',
      errorReason: `Could not find unique values for metric ${metricColumnHeaderValue}`,
    });
  }

  // An empty uniqueValues array means the transform truncated it due to > 1000 unique values,
  // which indicates a continuous (non-boolean) metric.
  if (uniqueMetricValues.uniqueValues.length === 0) {
    return okResult(false);
  }

  const nonBlankCount = uniqueMetricValues.uniqueValues.filter(
    (value) => !isBlankString(value),
  ).length;

  return okResult(nonBlankCount <= 2);
};
